<div class="static-page" *ngIf="page as currentPage; else notFound">
  <div class="static-page__topbar">
    <button
      pButton
      pRipple
      type="button"
      icon="pi pi-arrow-left"
      iconPos="left"
      class="static-page__back p-button-text p-button-sm"
      (click)="goBack()"
      [label]="'common.button.back' | translate">
    </button>
    <h1 class="static-page__title">{{ currentPage.title }}</h1>
  </div>
  <div class="static-page__scroll">
    <div class="static-page__container">
      <div class="static-page__header">
        <p *ngIf="currentPage.excerpt">{{ currentPage.excerpt }}</p>
      </div>
      <div class="static-page__content" [innerHTML]="currentPage.content"></div>
    </div>
  </div>
</div>

<ng-template #notFound>
  <div class="static-page">
    <div class="static-page__topbar">
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-arrow-left"
        iconPos="left"
        class="static-page__back p-button-text p-button-sm"
        (click)="goBack()"
        [label]="'common.button.back' | translate">
      </button>
      <h1 class="static-page__title">{{ 'common.no_data' | translate }}</h1>
    </div>
    <div class="static-page__scroll">
      <div class="static-page__container">
      </div>
    </div>
  </div>
</ng-template>
